export default __webpack_public_path__ + "assets/images/84956a273b8db8c6225ea16c5e81bb10.png";